"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveStatusBug = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_jss_1 = require("react-jss");
var useLiveStatusBugStyles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    // TODO: It likely makes sense to move the margin outside this class and allow containers
    //  to use padding or wrap with a container that has margin. Then the bug would be more
    //  flexible and let the developer choose how to place it, instead of intrinsic margin.
    bug: function (_a) {
        var size = _a.size;
        return ({
            display: "inline-block",
            width: size,
            height: size,
            backgroundColor: theme.colors.active,
            borderRadius: "50%",
            // eslint-disable-next-line @atg/css-rtl-support
            margin: "0 6px 0 0",
            position: "relative",
            // When the bug is not animated, we include a box-shadow.
            // TODO: It might be better to have a prop to indicate whether to show the shadow,
            //   but it might not even look very good in combination with the animation.
            // TODO: The size(s) of the box shadow should probably be based on the size of the bug.
            //   The current values are based on a 10px size.
            boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.5)",
        });
    },
}); });
var LiveStatusBug = function (props) {
    var classes = useLiveStatusBugStyles({ size: props.size });
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.bug }, props));
};
exports.LiveStatusBug = LiveStatusBug;
//# sourceMappingURL=LiveStatusBug.js.map